import { render, staticRenderFns } from "./beneficio.vue?vue&type=template&id=0319241e"
import script from "./beneficio.vue?vue&type=script&lang=js"
export * from "./beneficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports